var _rect, _path, _path2, _path3, _circle, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultSchoolLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#A1181F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 17L74 30L48 43L22 30L48 17Z",
    fill: "#F8C35B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 37V56C30 60.6 38.1 66 48 66C57.9 66 66 60.6 66 56V37L48 46L30 37Z",
    fill: "#FFF4DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 30V50",
    stroke: "#F8C35B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 54,
    r: 5,
    fill: "#F8C35B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 74H58",
    stroke: "#FFF4DA",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79H53",
    stroke: "#FFF4DA",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSchoolLogo);
export default __webpack_public_path__ + "static/media/default-school-logo.366a7c29fa6c1faa4d63251fcd7831c9.svg";
export { ForwardRef as ReactComponent };